module.exports = __webpack_public_path__ + "img/img_pocket_thunder.15fd6db1.png";